import classNames from "classnames";
import isNil from "lodash/isNil";
import { Tooltip } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import { getMatchDisplayValue } from "PFCore/helpers/match_value";
import { convertToPercentage } from "PFCore/utilities/math";

import css from "./match_scores.module.scss";

type MatchScoreProps = {
  title: string;
  score?: number | null;
  unit?: string;
  isBold?: boolean;
  light?: boolean;
};

export const MatchScore = ({ title, score, unit, isBold, light = false }: MatchScoreProps) => {
  const formatScore = (score: number, digits: number) =>
    getMatchDisplayValue(score, { digits, skipTrailingZeros: true });

  const tooltipValue = convertToPercentage(score, { decimalPlaces: 3, skipTrailingZeros: true });
  const hasScore = !isNil(score);
  const displayBold = isBold && hasScore;

  return (
    <div className={css.matchScore}>
      <Typography
        variant="labelRegular"
        className={classNames(css.title, {
          [css.light]: light
        })}
        title={title}
        textOverflow="clip"
      >
        {title}
      </Typography>
      <Tooltip content={tooltipValue} disabled={!hasScore} triggerContainerProps={{ className: css.value }}>
        <Typography
          variant="h1"
          className={classNames({
            [css.bold]: displayBold,
            [css.thin]: !displayBold,
            [css.light]: light
          })}
        >
          {hasScore ? formatScore(score, 0) : "-"}
        </Typography>
        {unit && hasScore && (
          <Typography
            withMargin
            variant="bodyRegular"
            tag="span"
            className={classNames(css.unit, css.bold, {
              [css.light]: light
            })}
          >
            {unit}
          </Typography>
        )}
      </Tooltip>
    </div>
  );
};
